var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "u-height-full" }, [
    _c("div", { staticClass: "c-navbar-desktop c-navbar__menu-wrapper" }, [
      _c(
        "ul",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.userIsActive(),
              expression: "userIsActive()",
            },
          ],
          staticClass: "c-navbar__menu-list",
        },
        [
          false
            ? _c("li", { staticClass: "c-navbar__menu-item" }, [_vm._m(0)])
            : _vm._e(),
          _vm._v(" "),
          _c("AllProgramsMenu"),
          _vm._v(" "),
          _c(
            "li",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showSubmissionsLink,
                  expression: "showSubmissionsLink",
                },
              ],
              staticClass: "c-navbar__menu-item",
              class:
                _vm.isPage("submission") && !_vm.isPage("programs")
                  ? "c-navbar__menu-item--active"
                  : "",
            },
            [_vm._m(1)]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showFindingsLink,
                  expression: "showFindingsLink",
                },
              ],
              staticClass: "c-navbar__menu-item",
              class:
                _vm.isPage("finding") && !_vm.isPage("programs")
                  ? "c-navbar__menu-item--active"
                  : "",
            },
            [_vm._m(2)]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showReportsLink,
                  expression: "showReportsLink",
                },
              ],
              staticClass: "c-navbar__menu-item",
              class: _vm.isPage("reports") ? "c-navbar__menu-item--active" : "",
            },
            [_vm._m(3)]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showPaymentsLink,
                  expression: "showPaymentsLink",
                },
              ],
              staticClass: "c-navbar__menu-item",
              class: _vm.isPage("my-payments")
                ? "c-navbar__menu-item--active"
                : "",
            },
            [_vm._m(4)]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              staticClass: "c-navbar__menu-item",
              class:
                _vm.isPage("bank") && !_vm.isPage("programs")
                  ? "c-navbar__menu-item--active"
                  : "",
            },
            [
              _c(
                "a",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.userIsBanker() || _vm.userIsProgramManager(),
                      expression: "userIsBanker() || userIsProgramManager()",
                    },
                  ],
                  staticClass: "c-navbar__menu-link u-cursor-pointer",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.onBankIconClick.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("span", { staticClass: "c-navbar__menu-link-text" }, [
                    _vm._v("Bank"),
                  ]),
                ]
              ),
            ]
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "c-navbar-mobile" }, [
      _c(
        "ul",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.userIsActive(),
              expression: "userIsActive()",
            },
          ],
          staticClass: "c-navbar__menu-list",
        },
        [
          false
            ? _c("li", { staticClass: "c-navbar__menu-item" }, [_vm._m(5)])
            : _vm._e(),
          _vm._v(" "),
          _c("AllProgramsMenu"),
          _vm._v(" "),
          _c(
            "li",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showSubmissionsLink,
                  expression: "showSubmissionsLink",
                },
              ],
              staticClass: "c-navbar__menu-item",
              class: _vm.isPage("submission")
                ? "c-navbar__menu-item--active"
                : "",
            },
            [_vm._m(6)]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showFindingsLink,
                  expression: "showFindingsLink",
                },
              ],
              staticClass: "c-navbar__menu-item",
              class: _vm.isPage("finding") ? "c-navbar__menu-item--active" : "",
            },
            [_vm._m(7)]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showReportsLink,
                  expression: "showReportsLink",
                },
              ],
              staticClass: "c-navbar__menu-item",
              class: _vm.isPage("reporttemplates")
                ? "c-navbar__menu-item--active"
                : "",
            },
            [_vm._m(8)]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showPaymentsLink,
                  expression: "showPaymentsLink",
                },
              ],
              staticClass: "c-navbar__menu-item",
              class: _vm.isPage("UserProfileTransactions")
                ? "c-navbar__menu-item--active"
                : "",
            },
            [_vm._m(9)]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              staticClass: "c-navbar__menu-item",
              class: _vm.isPage("bank") ? "c-navbar__menu-item--active" : "",
            },
            [
              _c(
                "a",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.userIsBanker() || _vm.userIsProgramManager(),
                      expression: "userIsBanker() || userIsProgramManager()",
                    },
                  ],
                  staticClass: "c-navbar__menu-link u-cursor-pointer",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.onBankIconClick.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("span", { staticClass: "c-navbar__menu-link-text" }, [
                    _vm._v("Bank"),
                  ]),
                ]
              ),
            ]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      { staticClass: "c-navbar__menu-link", attrs: { href: "#/dashboard" } },
      [
        _c("span", { staticClass: "c-navbar__menu-link-text" }, [
          _vm._v("Dashboard"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      { staticClass: "c-navbar__menu-link", attrs: { href: "#/submissions" } },
      [
        _c("span", { staticClass: "c-navbar__menu-link-text" }, [
          _vm._v("Submissions"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      { staticClass: "c-navbar__menu-link", attrs: { href: "#/findings" } },
      [
        _c("span", { staticClass: "c-navbar__menu-link-text" }, [
          _vm._v("Vulnerabilities"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "c-navbar__menu-link",
        attrs: { href: "#/reports/templates" },
      },
      [
        _c("span", { staticClass: "c-navbar__menu-link-text" }, [
          _vm._v("Reports"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "c-navbar__menu-link",
        attrs: { href: "#/bank/my-payments" },
      },
      [
        _c("span", { staticClass: "c-navbar__menu-link-text" }, [
          _vm._v("Payments"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      { staticClass: "c-navbar__menu-link", attrs: { href: "#/dashboard" } },
      [
        _c("span", { staticClass: "c-navbar__menu-link-text" }, [
          _vm._v("Dashboard"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      { staticClass: "c-navbar__menu-link", attrs: { href: "#/submissions" } },
      [
        _c("span", { staticClass: "c-navbar__menu-link-text" }, [
          _vm._v("Submissions"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      { staticClass: "c-navbar__menu-link", attrs: { href: "#/findings" } },
      [
        _c("span", { staticClass: "c-navbar__menu-link-text" }, [
          _vm._v("Vulnerabilities"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "c-navbar__menu-link",
        attrs: { href: "#/reports/templates" },
      },
      [
        _c("span", { staticClass: "c-navbar__menu-link-text" }, [
          _vm._v("Reports"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "c-navbar__menu-link",
        attrs: { href: "#/bank/my-payments" },
      },
      [
        _c("span", { staticClass: "c-navbar__menu-link-text" }, [
          _vm._v("Payments"),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }